import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunkMiddleware from 'redux-thunk';

import { setStore } from './state';
import reducer from './reducer';
import refHandler from './enhancer';

export default function makeStore(initialState = {}) {
  const middleware = process.env.NODE_ENV === 'development'
    ? [reduxImmutableStateInvariant(), thunkMiddleware, refHandler]
    : [thunkMiddleware, refHandler];

  const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware)),
  );

  // Set the store in the state utilities to be
  // used by utilities not connected to redux.
  setStore(store);

  return store;
}
